// extracted by mini-css-extract-plugin
module.exports = {"box":"dialog-person-total-duration_box_1Sfcq","pRange":"dialog-person-total-duration_pRange_1cjLp"};